import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const Blog = () => {
  const blogPosts = [
    {
      id: 'comfyui-tutorial',
      title: "如何使用ComfyUI进行AI创作",
      excerpt: "探索ComfyUI的工作流程和使用技巧，从基础设置到高级应用，帮助你快速掌握AI创作要领...",
      date: "2024-01-15",
      category: "AI工具"
    },
    {
      id: 'competitor-analysis',
      title: "为什么我们在构建产品前先寻找你的对手",
      excerpt: "在开始产品开发之前，了解市场竞争对手是至关重要的。本文将分享如何进行竞品分析，以及如何利用这些信息来优化你的产品策略...",
      date: "2024-01-20",
      category: "产品策略"
    },
    {
      id: 'no-code-development',
      title: "不懂代码，如何构建网站和产品",
      excerpt: "即使不会编程，现在也有很多工具可以帮助你构建专业的网站和产品。从No-code工具到AI辅助开发，探索适合非技术人员的解决方案...",
      date: "2024-01-25",
      category: "技术工具"
    },
    {
      id: 'figma-workflow',
      title: "Figma如何改变我们的设计方式",
      excerpt: "Figma作为现代设计工具，彻底改变了设计师的工作方式。从协作特性到插件生态，探索Figma如何提升设计效率...",
      date: "2024-02-01",
      category: "设计工具"
    },
    {
      id: 'market-analysis',
      title: "为什么要时刻关注市场",
      excerpt: "市场洞察对产品成功至关重要。了解如何建立市场监测机制，捕捉市场趋势，及时调整产品策略以保持竞争力...",
      date: "2024-02-05",
      category: "市场分析"
    },
    {
      id: 'user-needs',
      title: "需求才是产品的源头",
      excerpt: "深入探讨需求分析的重要性，如何准确捕捉用户痛点，将需求转化为产品功能，打造真正解决问题的产品...",
      date: "2024-02-10",
      category: "产品设计"
    }
  ];

  return (
    <div className="blog-page">
      <div className="blog-header">
        <div className="header-content">
          <h1>Blog</h1>
          <p>分享我的想法、经验和见解</p>
        </div>
        <div className="header-image">
          <img src="/images/about_me.png" alt="Blog Header" />
        </div>
      </div>

      <div className="blog-grid">
        {blogPosts.map(post => (
          <Link to={`/blog/${post.id}`} key={post.id} className="blog-card">
            <div className="blog-card-content">
              <div className="blog-meta">
                <span className="blog-date">{post.date}</span>
                <span className="blog-category">{post.category}</span>
              </div>
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>
              <span className="read-more">阅读更多 <span>→</span></span>
            </div>
          </Link>
        ))}
      </div>

      <ContactCTA />
    </div>
  );
};

export default Blog; 